import Col from './col';
export { SIZES } from './col';
export default Col;
